export const languages = [
  {
    code: 'en',
    name: 'English',
    flag: '🇬🇧'
  },
  {
    code: 'ja',
    name: '日本語',
    flag: '🇯🇵'
  },
  {
    code: 'zh',
    name: '中文',
    flag: '🇨🇳'
  },
  {
    code: 'ko',
    name: '한국어',
    flag: '🇰🇷'
  },
  {
    code: 'es',
    name: 'Español',
    flag: '🇪🇸'
  },
  {
    code: 'fr',
    name: 'Français',
    flag: '🇫🇷'
  },
  {
    code: 'de',
    name: 'Deutsch',
    flag: '🇩🇪'
  },
  {
    code: 'it',
    name: 'Italiano',
    flag: '🇮🇹'
  },
  {
    code: 'pt',
    name: 'Português',
    flag: '🇵🇹'
  },
  {
    code: 'ru',
    name: 'Русский',
    flag: '🇷🇺'
  }
];

export const translations = {
  en: {
    prefecturesVisited: 'Prefectures Visited',
    totalScore: 'Total Score',
    experienceLevels: 'Experience Levels',
    level: 'Level',
    export: 'Export',
    share: 'Share',
    shareTitle: 'My Japan Travel Map',
    shareText: 'Check out my Japan travel experience!',
    shareInstagramHint: 'Image downloaded! You can now share it on Instagram.',
    experiences: {
      '5': 'Lived there',
      '4': 'Stayed there',
      '3': 'Visited there',
      '2': 'Alighted there',
      '1': 'Passed there',
      '0': 'Never been there'
    },
    layout: 'Layout',
    selectMap: 'Select Map',
    japanMap: 'Japan Map',
    chinaMap: 'China Map',
  },
  ja: {
    prefecturesVisited: '訪問した都道府県',
    totalScore: '合計スコア',
    experienceLevels: '体験レベル',
    level: 'レベル',
    export: 'エクスポート',
    share: 'シェア',
    shareTitle: '私の日本旅行マップ',
    shareText: '私の日本旅行体験をチェックしてください！',
    shareInstagramHint: '画像をダウンロードしました！Instagramで共有できます。',
    experiences: {
      '5': '住んでいた',
      '4': '宿泊した',
      '3': '訪問した',
      '2': '立ち寄った',
      '1': '通過した',
      '0': '行ったことがない'
    },
    layout: 'レイアウト',
    selectMap: '地図を選択',
    japanMap: '日本地図',
    chinaMap: '中国地図',
  },
  zh: {
    prefecturesVisited: '已访问县份',
    totalScore: '总分',
    experienceLevels: '体验等级',
    level: '等级',
    export: '导出',
    share: '分享',
    shareTitle: '我的日本旅行地图',
    shareText: '来看看我的日本旅行体验！',
    shareInstagramHint: '图片已下载！现在可以在Instagram上分享了。',
    experiences: {
      '5': '居住过',
      '4': '住宿过',
      '3': '访问过',
      '2': '短暂停留',
      '1': '路过',
      '0': '从未去过'
    },
    layout: '布局',
    selectMap: '选择地图',
    japanMap: '日本地图',
    chinaMap: '中国地图',
  },
  ko: {
    prefecturesVisited: '방문한 현',
    totalScore: '총점',
    experienceLevels: '경험 수준',
    level: '레벨',
    export: '내보내기',
    share: '공유',
    shareTitle: '나의 일본 여행 지도',
    shareText: '내 일본 여행 경험을 확인해보세요!',
    shareInstagramHint: '이미지가 다운로드되었습니다! 이제 Instagram에서 공유할 수 있습니다.',
    experiences: {
      '5': '거주했음',
      '4': '숙박했음',
      '3': '방문했음',
      '2': '들렀음',
      '1': '지나갔음',
      '0': '가본 적 없음'
    },
    layout: '레이아웃',
    selectMap: '지도 선택',
    japanMap: '일본 지도',
    chinaMap: '중국 지도',
  },
  es: {
    prefecturesVisited: 'Prefecturas Visitadas',
    totalScore: 'Puntuación Total',
    experienceLevels: 'Niveles de Experiencia',
    level: 'Nivel',
    export: 'Exportar',
    share: 'Compartir',
    shareTitle: 'Mi Mapa de Viajes por Japón',
    shareText: '¡Mira mi experiencia viajando por Japón!',
    shareInstagramHint: '¡Imagen descargada! Ahora puedes compartirla en Instagram.',
    experiences: {
      '5': 'Viví allí',
      '4': 'Me alojé allí',
      '3': 'Visité allí',
      '2': 'Hice escala allí',
      '1': 'Pasé por allí',
      '0': 'Nunca he estado'
    },
    layout: 'Diseño',
    selectMap: 'Seleccionar Mapa',
    japanMap: 'Mapa de Japón',
    chinaMap: 'Mapa de China',
  },
  fr: {
    prefecturesVisited: 'Préfectures Visitées',
    totalScore: 'Score Total',
    experienceLevels: 'Niveaux d\'Expérience',
    level: 'Niveau',
    export: 'Exporter',
    share: 'Partager',
    shareTitle: 'Ma Carte de Voyage au Japon',
    shareText: 'Découvrez mon expérience de voyage au Japon !',
    shareInstagramHint: 'Image téléchargée ! Vous pouvez maintenant la partager sur Instagram.',
    experiences: {
      '5': 'J\'y ai vécu',
      '4': 'J\'y ai séjourné',
      '3': 'J\'ai visité',
      '2': 'J\'y ai fait escale',
      '1': 'Je suis passé par là',
      '0': 'Jamais visité'
    },
    layout: 'Mise en page',
    selectMap: 'Sélectionner une carte',
    japanMap: 'Carte du Japon',
    chinaMap: 'Carte de la Chine',
  },
  de: {
    prefecturesVisited: 'Besuchte Präfekturen',
    totalScore: 'Gesamtpunktzahl',
    experienceLevels: 'Erfahrungsstufen',
    level: 'Stufe',
    export: 'Exportieren',
    share: 'Teilen',
    shareTitle: 'Meine Japan-Reisekarte',
    shareText: 'Schau dir meine Japan-Reiseerfahrung an!',
    shareInstagramHint: 'Bild heruntergeladen! Du kannst es jetzt auf Instagram teilen.',
    experiences: {
      '5': 'Dort gelebt',
      '4': 'Dort übernachtet',
      '3': 'Dort besucht',
      '2': 'Dort zwischengelandet',
      '1': 'Dort durchgereist',
      '0': 'Noch nie gewesen'
    },
    layout: 'Layout',
    selectMap: 'Karte auswählen',
    japanMap: 'Japan-Karte',
    chinaMap: 'China-Karte',
  },
  it: {
    prefecturesVisited: 'Prefetture Visitate',
    totalScore: 'Punteggio Totale',
    experienceLevels: 'Livelli di Esperienza',
    level: 'Livello',
    export: 'Esporta',
    share: 'Condividi',
    shareTitle: 'La Mia Mappa dei Viaggi in Giappone',
    shareText: 'Guarda la mia esperienza di viaggio in Giappone!',
    shareInstagramHint: 'Immagine scaricata! Ora puoi condividerla su Instagram.',
    experiences: {
      '5': 'Ci ho vissuto',
      '4': 'Ci ho soggiornato',
      '3': 'Ho visitato',
      '2': 'Ci ho fatto scalo',
      '1': 'Ci sono passato',
      '0': 'Non ci sono mai stato'
    },
    layout: 'Layout',
    selectMap: 'Seleziona Mappa',
    japanMap: 'Mappa del Giappone',
    chinaMap: 'Mappa della Cina',
  },
  pt: {
    prefecturesVisited: 'Prefeituras Visitadas',
    totalScore: 'Pontuação Total',
    experienceLevels: 'Níveis de Experiência',
    level: 'Nível',
    export: 'Exportar',
    share: 'Compartilhar',
    shareTitle: 'Meu Mapa de Viagem do Japão',
    shareText: 'Confira minha experiência de viagem no Japão!',
    shareInstagramHint: 'Imagem baixada! Agora você pode compartilhar no Instagram.',
    experiences: {
      '5': 'Morei aqui',
      '4': 'Me hospedei aqui',
      '3': 'Visitei aqui',
      '2': 'Fiz escala aqui',
      '1': 'Passei por aqui',
      '0': 'Nunca estive'
    },
    layout: 'Layout',
    selectMap: 'Selecionar Mapa',
    japanMap: 'Mapa do Japão',
    chinaMap: 'Mapa da China',
  },
  ru: {
    prefecturesVisited: 'Посещенные префектуры',
    totalScore: 'Общий счет',
    experienceLevels: 'Уровни опыта',
    level: 'Уровень',
    export: 'Экспорт',
    share: 'Поделиться',
    shareTitle: 'Моя карта путешествий по Японии',
    shareText: 'Посмотрите мой опыт путешествий по Японии!',
    shareInstagramHint: 'Изображение загружено! Теперь вы можете поделиться им в Instagram.',
    experiences: {
      '5': 'Жил здесь',
      '4': 'Останавливался здесь',
      '3': 'Посетил здесь',
      '2': 'Был проездом',
      '1': 'Проезжал мимо',
      '0': 'Никогда не был'
    },
    layout: 'Макет',
    selectMap: 'Выберите карту',
    japanMap: 'Карта Японии',
    chinaMap: 'Карта Китая',
  }
};